import axios from "axios";

axios.defaults.withCredentials = true;

export default 
{
    async saveInsee(insee)
    {
        var dataFile = new FormData();
        dataFile.append("file",insee.nameFile,insee.nameFile.name);
        console.log(insee.nameFile)
        var exportInseeString = JSON.stringify(insee);
        var exportInsee = JSON.parse(exportInseeString);
        exportInsee.nameFile = exportInsee.nameFile.name;
        dataFile.append("insee", JSON.stringify(exportInsee));
        const changementInsee = await axios.post(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_INSEE, dataFile
                , {
                    "content-type": "multipart/form-data",
                });
                return changementInsee.data;
            },

            async getDemandesGestionnaire()
            {
                const demandes = await axios.get(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_INSEE + "/drh/forGestionnaire");
                return demandes.data;
            },
        
            async getDemandeFileDRH(idFile)
            {
                return process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_FILE_INSEE_DRH + idFile;
            },
        
            async updateDemande(insee)
            {
                return (await axios.put(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_INSEE + "/drh",insee, {"content-type" : "application/json"})).data;
            },
        
            async getDemandes()
            {
                return (await axios.get(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_INSEE)).data;
            },

        }